<template>
    <ValidationProvider :rules="rules" v-slot="{ errors }">
        <div class="w-full flex my-2">
            <label class="checkbox-label checkbox-label--team mt-1">
                <input
                    :class="classes"
                    @change="onChange"
                    :value="value"
                    :name="name"
                    :id="id"
                    :type="type"
                    :checked="state"
                    :disabled="disabled" />
                <span class="checkmark checkmark--team"></span
            ></label>
            <div class="ml-0 mt-1" v-html="description"></div>
        </div>
        <transition name="fade">
            <span id="error" class="text-red-600">{{
                errors[0] ? errorText : null
            }}</span>
        </transition>
    </ValidationProvider>
</template>

<script>
export default {
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    props: {
        value: {
            type: String,
            default: '',
            required: true,
        },
        modelValue: {
            default: undefined,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        rules: {
            type: Object,
            required: false,
            default: () => {},
        },
        errorText: {
            type: String,
            required: false,
            default: '',
        },
        type: {
            type: String,
            required: false,
            default: 'radio',
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        model: {},
    },
    computed: {
        state() {
            if (this.modelValue === undefined) {
                return this.checked;
            }
            return this.modelValue === this.value;
        },
    },
    methods: {
        onChange() {
            this.toggle();
        },
        toggle() {
            this.$emit('input', this.state ? '' : this.value);
        },
    },
    watch: {
        checked(newValue) {
            if (newValue !== this.state) {
                this.toggle();
            }
        },
    },
    mounted() {
        if (this.checked && !this.state) {
            this.toggle();
        }
    },
};
</script>

<style>
.custom-label input:checked + svg {
    display: block !important;
}
</style>
